var render, staticRenderFns
import script from "./NoticeTips.vue?vue&type=script&lang=js"
export * from "./NoticeTips.vue?vue&type=script&lang=js"
import style0 from "./NoticeTips.vue?vue&type=style&index=0&id=43eaa0a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43eaa0a6",
  null
  
)

export default component.exports